export const videoCallConstants = {
    CALL_DENIED: 'CALL_DENIED',
    TARGET_HANGUP: 'TARGET_HANGUP',
    SELF_HANGUP: 'SELF_HANGUP'
}